import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import { DisplayTimesheetEntryContractorVisit } from "../types";
import { Badge } from "@/components/ui/badge";

export const TimesheetHeader = memo(
  ({
    getValue,
    row,
  }: CellContext<DisplayTimesheetEntryContractorVisit, number>) => (
    <span className="text-sm flex flex-row gap-2 items-center gap-3 m-[-2px]">
      <Badge className="text-xs px-1 py-0 bg-slate-600 text-slate-100">
        {getValue()}
      </Badge>
      <span className="font-bold">{row.original.group_month}</span>
      <span>{row.original.store_name}</span>
      <span className="text-slate-500">
        ({row.original.payroll_department_name})
      </span>
    </span>
  ),
);
